import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                {props.data
                    ? props.data.paragraphs.map((d, i) => (
                  <h2 key={"subtitle"+i}>{d}</h2>
                )) : <></> }
                <a
                  href="#permis"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  En savoir plus
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
